module.exports = __webpack_public_path__ + "img/postbox.dd959ca9.png";